import React from "react"
import {Select} from 'antd';
import {BiChevronDown} from 'react-icons/bi'
import "./select-field.scss"

export default function SelectField(options) {
    function onClearSelect() {
        options.setValue(options.fieldName, null)
    }
    return(
        <div className={`select-field ${options.className} `}>
            {
                options.label && (
                    <label className={'field-label'}>{options.label} <span className={'steric'}>*</span></label>
                )
            }
            <Select
                allowClear={true}
                onClear={onClearSelect}
                showSearch={options.showSearch}
                placeholder={options.placeholder ? options.placeholder : 'Please Select'}
                // optionFilterProp="children"
                // filterOption={(input, option) => (option?.label ?? '').includes(input)}
                // filterSort={(optionA, optionB) =>
                //     (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                // }
                value={options.value && options.value}
                status={options.errors && 'error'}
                suffixIcon={<BiChevronDown size={23}/>}
                options={options.options}
                autoComplete="off"
                defaultValue={options.defaultValue}
                onSelect={(value, option) => {
                    // console.log(value, option)
                    options.setValue(options.fieldName, value)
                }}
                // mode={'multiple'}
            />
            {
                <div className="errors">
                    {options.errors && <small className="error-message">{options.errors.message}</small>}
                </div>
            }
        </div>
    )
}